import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2, AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { customStringsAdminRouter } from './routing/customStringsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { customStringsAccessControl } from './access-control/customStringsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'custom-strings',
  totem: {
    tool: 'custom-strings-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [customStringsAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      attachToV3: AdminNavEntryPointV3.PartnerSettings,
      subNavItems: [
        {
          route: 'custom-strings-list',
          subRoutes: ['custom-strings-create'],
          labelId: 'customStringsDomain.list.title',
          accessControl: customStringsAccessControl,
          positionNavV2: 10,
          // Last L2 in v3 Partner settings group 3. Sentence-case transform
          // yields "Custom strings" — no labelIdV3 needed.
          positionNavV3: 9,
        },
      ],
    },
  ],
  // NOTE TO DEV: run `yarn ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
